import { render } from "./layered.vue?vue&type=template&id=81b8ec92"
import script from "./layered.vue?vue&type=script&lang=js"
export * from "./layered.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__